<mat-icon
    *ngIf="!fullscreenService.isFullscreenImageActive"
    class="material-icons" svgIcon="image__button-fullscreen"
    role="button"
    tabindex="0"
    (click)="fullscreenService.openFullscreen(target, $event)"
    (keyup.enter)="fullscreenService.openFullscreen(target, $event)"
    (keyup.space)="fullscreenService.openFullscreen(target, $event)"
    [matTooltip]="'activities.lesson.display' | translate">
</mat-icon>